import { useSearchParams } from 'react-router-dom';

import { Group, Pagination, Select, Space } from '@mantine/core';

interface PaginationRowProps {
  page: number;
  pageLength: number;
  totalPages: number;
  onPageChange: (newPage: number) => void;
  onPageLengthChange: (newPageLength: number) => void;
  isLoading?: boolean;
  pageOptions?: number[];
}

export default function PaginationRow({
  page,
  pageLength,
  totalPages,
  onPageChange,
  onPageLengthChange,
  isLoading,
  pageOptions = [5, 10, 20, 50],
}: PaginationRowProps) {
  const [searchParams, setSearchParams] = useSearchParams();

  // ==========================================================================
  // Handlers
  // ==========================================================================
  const handlePageChange = (newPage: number) => {
    setSearchParams({ ...searchParams, page: newPage.toString() });
    onPageChange(newPage);
  };

  const handlePageLengthChange = (newPageLength: number) => {
    setSearchParams({ ...searchParams, pageLength: newPageLength.toString() });
    onPageLengthChange(newPageLength);
  };

  // ==========================================================================
  // Render
  // ==========================================================================
  return (
    <Group justify="space-between" mt="xl">
      <Pagination
        disabled={isLoading}
        style={{ visibility: totalPages > 1 ? 'visible' : 'hidden' }}
        value={page}
        onChange={handlePageChange}
        total={totalPages}
      />
      <Space />
      <Select
        disabled={isLoading}
        allowDeselect={false}
        aria-label="Elementi per pagina"
        style={{ width: '5em' }}
        data={pageOptions.map((opt) => opt.toString())}
        value={pageLength.toString()}
        onChange={(value) => handlePageLengthChange(+value!)}
      />
    </Group>
  );
}
